var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quit-developer-view-root"},[_vm._v("\n  開発者モード終了しました。\n")])}
var staticRenderFns = []

export { render, staticRenderFns }